<div class="dropdown-holder">
  <div
    class="header"
    [class.justify-center]="!showActiveInfo"
    [suiMenuTrigger]="moduleMenu"
  >
    <div class="active-module-info">
      <fa-icon [icon]="activeModule.icon"></fa-icon>
      <div *ngIf="showActiveInfo" class="active-module">
        {{ activeModule.name }}
      </div>
    </div>
    <fa-icon
      *ngIf="showActiveInfo"
      class="dropdown-toggle"
      [icon]="['fas', 'bars']"
    ></fa-icon>
  </div>
  <ng-template #moduleMenu>
    <sui-menu>
      <sui-menu-header>
        {{ "module-switch.title.switch-to" | translate }}:
      </sui-menu-header>
      <sui-menu-separator></sui-menu-separator>
      <button
        sui-menu-item
        *ngFor="let module of availableModules"
        [selected]="module.active"
        (click)="switchModule(module)"
      >
        <fa-icon *ngIf="module.icon" [icon]="module.icon"></fa-icon>
        <span>{{ module?.name }}</span>
      </button>
    </sui-menu>
  </ng-template>
</div>
